module.exports = __webpack_public_path__ + "img/innovators_logo_orange.c455f686.png";